import React, {useEffect} from 'react';
import Header from '../presentations/Header';
import FullScreenContainer from '../presentations/FullScreenContainer';
import ResetPasswordFormComplete from '../presentations/ResetPasswordFormComplete';
import {useTranslation} from 'react-i18next';
import { appEnv } from '../config/env';

const ResetPasswordComplete = () => {
  const {t} = useTranslation();

  useEffect(() => {
    document.title = `${appEnv.name} - ${t('Password Reset')}`;
  }, []);

  return (
          <>
            <Header/>

            <FullScreenContainer centering={true}>
              <main>
                <ResetPasswordFormComplete/>
              </main>
            </FullScreenContainer>
          </>
  );
};

export default ResetPasswordComplete;
